import "core-js/modules/es.array.push.js";
import { $h, Tips, basePost, baseTokenPost, U, baseGet, URL, SplitArray, urlParams } from '@/utils/util.js';
import { client, headers, getFileNameUUID } from '@/utils/alioss.js';
import zrcheader from '@/components/zrcheader/index.vue';
import zrcfooter from '@/components/zrcfooter/index.vue';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
export default {
  name: 'ProjectdetailView',
  components: {
    zrcheader,
    zrcfooter
  },
  data() {
    return {
      zrctoken: '',
      id: 0,
      userinfo: {
        xingming: '',
        uid: 0
      },
      //用户信息

      yugufeiyong: 0,
      //预估费用
      qianchulilist: [],
      //前处理类型
      fensanjilist: [],
      //分散剂类型
      zhibeilist: [],
      //制备类型
      chaoshengsjlist: [],
      //超声时间类型
      ceshitypelist: [],
      //测试方式
      shebeitypelist: [],
      //设备方式
      baocunlist: [],
      //保存类型
      cixinglist: [],
      //磁性类型
      afmtypelist: [],
      //AFM类型
      weixianlist: [],
      //危险类型
      yiqishebeilist: [],
      //仪器类型
      zhuangtailist: [],
      //状态类型
      hourlist: [],
      //小时类型
      ceshimingxilist: [],
      //测试项目列表
      huishoutypelist: [],
      //样品回收里类型
      quyangtypelist: [],
      //样品送样类型
      quyangzhutilist: [],
      //取样地址类型
      projectinfo: [],
      //客户合同信息
      dingdanlist: [],
      //客户合同附件列表
      huishoutype_beizhu: '',
      quyangtype_beizhu: '',
      ceshifangfalist: [],
      //测试方法类型
      shujuxingshilist: [],
      //数据形式类型
      shifoulist: [],
      //是否类型
      phzhilist: [],
      //PH值类型
      ceshimoshilist: [],
      //测试模式类型
      ceshicanshulist: [],
      //测试参数类型
      bochangfanweilist: [],
      //波长范围类型
      ziyoujitypelist: [],
      //自由基类型
      ziyoujitimedianshulist: [],
      //自由基时间点数
      guangzhaobwlist: [],
      //光照/变温

      folderName: '',
      dingdaninfo: {
        "project_id": 0,
        "sampnum": 1,
        "sampbianhao": '',
        "xzshebeitypeid": 0,
        "xzyiqishebeiid": 0,
        "xzceshitypeid": 0,
        "xzhourid": 0,
        "xzbaocunid": 0,
        "xzbaocunbeizhu": '',
        "xzweixianid": 0,
        "xzcixingid": 0,
        "xzafmtypeid": 0,
        "xzzhuangtaiid": 0,
        "xzzhuangtaibeizhu": '',
        'xzqianchuliid': 0,
        'xzqianchulibeizhu': '',
        'xzfensanjiid': 0,
        'xzfensanjibeizhu': '',
        'xzzhibeiid': 0,
        'xzzhibeibeizhu': '',
        'xzchaoshengsjid': 0,
        'xzchaoshengsjbeizhu': '',
        "sampxinxi": '',
        "xzceshixiangmuids": [],
        "dianjingfadabeishu": '',
        "nengpuyaoqiu": '',
        "ceshiyaoqiu": '',
        "shiyanbeizhu": '',
        "yujisongyangtime": '',
        "xzhuishoutypeid": 0,
        "huishou_name": '',
        "huishou_tel": '',
        "huishou_dizhi": '',
        "shiyan_lianxiren_name": '',
        "shiyan_lianxiren_tel": '',
        "xzquyangtypeid": 0,
        "quyang_address_id": 0,
        "quyang_address_detail": '',
        "xzceshifangfaid": 0,
        "xzshujuxingshiid": 0,
        "xzischaoshengid": 0,
        "chaoshen_fenzhong": '',
        "yangp_kelifanwei": '',
        "xzistiaojiephzhiid": 0,
        "xzphzhiid": 0,
        "ph_zhi": '',
        "yangp_zheshelv": '',
        "texing_rongjiyelongdu": '',
        "texing_ceshimian": '',
        "xzceshimoshiid": 0,
        "xzceshicanshuid": 0,
        "xzbochangfanweiid": 0,
        "shijibochangfanwei": '',
        'epr_diwenshifou_id': 0,
        //EPR低温是否
        'epr_diliangfxshifou_id': 0,
        //EPR低温定量分析是否
        'epr_guangzbg_id': 0,
        //EPR光照/变温ID
        'epr_ziyoujitype_id': 0,
        //	EPR自由基类型ID
        'epr_ziyoujitimedianshu_id': 0,
        //EPR自由基时间点数ID

        "fujianname": [],
        "fujianlist": []
      },
      loadingStatus: true,
      xzmenu: 2 //菜单选中
    };
  },
  created() {
    var that = this;
    this.getParams();
    let myDate = new Date();
    let year = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
    let Month = myDate.getMonth(); //获取当前月份(0-11,0代表1月)
    let date = myDate.getDate(); //获取当前日(1-31)

    // 此处假设name='test'
    // 那么这张图片就会放在根目录下webUpload文件夹下test文件夹下,xxxx-xx-xx文件夹内
    that.folderName = `zcbzpic/${year}-${Month + 1}-${date}/`;
    setTimeout(() => {
      this.loadingStatus = false;
    }, 2000);
  },
  onLoad(option) {
    console.log('参数');
  },
  watch: {
    '$route'(to, from) {
      // 在mounted函数执行的方法，放到该处
      // 加载页面数据的方法
      var that = this;
      console.log(to.query);
      that.id = to.query.id || 1;
      that.xzmenu = that.numToStr(to.query.xzmenu) || 1;
      that.dingdaninfo.project_id = option.id || 1;
      that.get_project_details(); //获取指定项目的信息
    }
  },
  methods: {
    getParams() {
      var that = this;
      // 取到路由带过来的参数
      console.log(that.$route.query);
      const option = this.$route.query;
      that.id = option.id || 1;
      that.xzmenu = that.numToStr(option.xzmenu) || 1;
      that.dingdaninfo.project_id = option.id || 1;
    },
    numToStr(num) {
      num = num.toString();
      return num;
    },
    //这里是获取登录状态
    getdengluzt: function () {
      var that = this;
      that.zrctoken = store.state.zrctoken;
      console.log('这里是获取登录状态that.zrctoken' + that.zrctoken);
      if (that.zrctoken.length > 0)
        //正常获取到了token
        {
          var url = U({
            m: 'zrcwebapi/user',
            c: 'webuser_api',
            a: 'getuserinfo'
          }, URL);
          var data = {
            zrctoken: that.$data.zrctoken
          };
          baseTokenPost(that.$data.zrctoken, url, data, function (res) {
            that.userinfo = res.data.info.userinfo;
            that.get_project_data(); //获取指定项目的信息
          }, function (res) {
            router.push({
              path: '/login'
            });
          });
        } else
        //没有登录的
        {
          router.push({
            path: '/login'
          });
        }
    },
    //获取指定项目的信息
    get_project_data: function () {
      var that = this;
      let myDate = new Date();
      let year = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
      let Month = myDate.getMonth(); //获取当前月份(0-11,0代表1月)
      let date = myDate.getDate(); //获取当前日(1-31)

      // 此处假设name='test'
      // 那么这张图片就会放在根目录下webUpload文件夹下test文件夹下,xxxx-xx-xx文件夹内
      that.folderName = `zcbzpic/${year}-${Month + 1}-${date}/`;
      that.yugufeiyong = 0;
      that.dingdaninfo.sampnum = 1;
      that.dingdaninfo.sampbianhao = '';
      that.dingdaninfo.xzshebeitypeid = 0;
      that.dingdaninfo.xzyiqishebeiid = 0;
      that.dingdaninfo.xzceshitypeid = 0;
      that.dingdaninfo.xzhourid = 0;
      that.dingdaninfo.xzbaocunid = 0;
      that.dingdaninfo.xzbaocunbeizhu = '';
      that.dingdaninfo.xzweixianid = 0;
      that.dingdaninfo.xzcixingid = 0;
      that.dingdaninfo.xzafmtypeid = 0;
      that.dingdaninfo.xzzhuangtaiid = 0;
      that.dingdaninfo.xzzhuangtaibeizhu = '';
      that.dingdaninfo.xzqianchuliid = 0;
      that.dingdaninfo.xzqianchulibeizhu = '';
      that.dingdaninfo.xzfensanjiid = 0;
      that.dingdaninfo.xzfensanjibeizhu = '';
      that.dingdaninfo.xzzhibeiid = 0;
      that.dingdaninfo.xzzhibeibeizhu = '';
      that.dingdaninfo.xzchaoshengsjid = 0;
      that.dingdaninfo.xzchaoshengsjbeizhu = '';
      that.dingdaninfo.sampxinxi = '';
      that.dingdaninfo.xzceshixiangmuids = [];
      that.dingdaninfo.dianjingfadabeishu = '';
      that.dingdaninfo.nengpuyaoqiu = '';
      that.dingdaninfo.ceshiyaoqiu = '';
      that.dingdaninfo.shiyanbeizhu = '';
      that.dingdaninfo.yujisongyangtime = '';
      that.dingdaninfo.xzhuishoutypeid = 0;
      that.dingdaninfo.shiyan_lianxiren_name = '';
      that.dingdaninfo.shiyan_lianxiren_tel = '';
      that.dingdaninfo.xzquyangtypeid = 0;
      that.dingdaninfo.quyang_address_id = 0;
      that.dingdaninfo.quyang_address_detail = '';
      that.dingdaninfo.xzceshifangfaid = 0;
      that.dingdaninfo.xzshujuxingshiid = 0;
      that.dingdaninfo.xzischaoshengid = 0;
      that.dingdaninfo.chaoshen_fenzhong = '';
      that.dingdaninfo.yangp_kelifanwei = '';
      that.dingdaninfo.xzistiaojiephzhiid = 0;
      that.dingdaninfo.xzphzhiid = 0;
      that.dingdaninfo.ph_zhi = '';
      that.dingdaninfo.yangp_zheshelv = '';
      that.dingdaninfo.texing_rongjiyelongdu = '';
      that.dingdaninfo.texing_ceshimian = '';
      that.dingdaninfo.xzceshimoshiid = 0;
      that.dingdaninfo.xzceshicanshuid = 0;
      that.dingdaninfo.xzbochangfanweiid = 0;
      that.dingdaninfo.shijibochangfanwei = '';
      that.dingdaninfo.epr_diwenshifou_id = 0; //EPR低温是否
      that.dingdaninfo.epr_diliangfxshifou_id = 0; //EPR低温定量分析是否
      that.dingdaninfo.epr_guangzbg_id = 0; //EPR光照/变温ID
      that.dingdaninfo.epr_ziyoujitype_id = 0; //	EPR自由基类型ID
      that.dingdaninfo.epr_ziyoujitimedianshu_id = 0; //EPR自由基时间点数ID

      that.dingdaninfo.fujianname = [];
      that.dingdaninfo.fujianlist = [];
      var url = U({
        m: 'zrcwebapi/user',
        c: 'webuser_api',
        a: 'project_data'
      }, URL);
      var data = {
        zrctoken: that.$data.zrctoken,
        id: that.$data.id
      };
      baseTokenPost(that.$data.zrctoken, url, data, function (res) {
        that.projectinfo = res.data.info.projectinfo; //客户合同信息
        that.qianchulilist = res.data.info.qianchulilist; //前处理类型
        that.fensanjilist = res.data.info.fensanjilist; //分散剂类型
        that.zhibeilist = res.data.info.zhibeilist; //制备类型
        that.chaoshengsjlist = res.data.info.chaoshengsjlist; //超声时间类型
        that.ceshitypelist = res.data.info.ceshitypelist; //测试方式
        that.shebeitypelist = res.data.info.shebeitypelist; //设备方式
        that.baocunlist = res.data.info.baocunlist; //保存类型
        that.cixinglist = res.data.info.cixinglist; //磁性类型
        that.afmtypelist = res.data.info.afmtypelist; //AFM类型
        that.weixianlist = res.data.info.weixianlist; //危险类型
        that.yiqishebeilist = res.data.info.yiqishebeilist; //仪器类型
        that.zhuangtailist = res.data.info.zhuangtailist; //状态类型
        that.hourlist = res.data.info.hourlist; //小时类型
        that.ceshimingxilist = res.data.info.ceshimingxilist; //测试项目
        that.huishoutypelist = res.data.info.huishoutypelist; //样品回收里类型
        that.quyangtypelist = res.data.info.quyangtypelist; //样品送样类型
        that.quyangzhutilist = res.data.info.quyangzhutilist; //取样地址类型

        that.ceshifangfalist = res.data.info.ceshifangfalist; //测试方法类型
        that.shujuxingshilist = res.data.info.shujuxingshilist; //数据形式类型
        that.shifoulist = res.data.info.shifoulist; //是否类型
        that.phzhilist = res.data.info.phzhilist; //PH值类型
        that.ceshimoshilist = res.data.info.ceshimoshilist; //测试模式类型
        that.ceshicanshulist = res.data.info.ceshicanshulist; //测试参数类型
        that.bochangfanweilist = res.data.info.bochangfanweilist; //波长范围类型
        that.ziyoujitypelist = res.data.info.ziyoujitypelist; //自由基类型
        that.ziyoujitimedianshulist = res.data.info.ziyoujitimedianshulist; //自由基时间点数
        that.guangzhaobwlist = res.data.info.guangzhaobwlist; //光照/变温

        that.dingdanlist = res.data.info.dingdanlist.list; //订单列表

        that.dingdaninfo.shiyan_lianxiren_name = res.data.info.shiyan_lianxiren_name; //实验联系人
        that.dingdaninfo.shiyan_lianxiren_tel = res.data.info.shiyan_lianxiren_tel; //实验联系电话
        that.dingdaninfo.sampbianhao = res.data.info.sampbianhao;
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //选择样品数量
    self_sampnum_Change: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi/user',
        c: 'webuser_api',
        a: 'sampbianhaoinfo'
      }, URL);
      var data = {
        zrctoken: that.$data.zrctoken,
        sampnum: that.dingdaninfo.sampnum
      };
      baseTokenPost(that.$data.zrctoken, url, data, function (res) {
        that.dingdaninfo.sampbianhao = res.data.info.sampbianhao;
        that.getyugufeiyong();
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //预估费用
    getyugufeiyong: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi/user',
        c: 'webuser_api',
        a: 'yugufeiyong'
      }, URL);
      var data = that.dingdaninfo;
      data['zrctoken'] = that.$data.zrctoken;
      baseTokenPost(that.$data.zrctoken, url, data, function (res) {
        that.yugufeiyong = res.data.info.yugufeiyong;
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //获取订单项目明细
    getceshixiangmu: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi/user',
        c: 'webuser_api',
        a: 'getceshixiangmu'
      }, URL);
      var data = that.dingdaninfo;
      data['zrctoken'] = that.$data.zrctoken;
      baseTokenPost(that.$data.zrctoken, url, data, function (res) {
        that.ceshimingxilist = res.data.info.ceshimingxilist; //测试项目
        that.dingdaninfo.xzceshixiangmuids = [];
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //选择样品回收
    self_huishoutype_Change() {
      var that = this;
      var url = U({
        m: 'zrcwebapi/user',
        c: 'webuser_api',
        a: 'huishoutypeinfo'
      }, URL);
      var data = {
        zrctoken: that.$data.zrctoken,
        id: that.dingdaninfo.xzhuishoutypeid
      };
      baseTokenPost(that.$data.zrctoken, url, data, function (res) {
        that.huishoutype_beizhu = res.data.info.huishoutypeinfo.info.huishoutypeinfo.beizhu;
        that.getyugufeiyong();
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //选择样品送样方式
    self_quyangtype_Change() {
      var that = this;
      var url = U({
        m: 'zrcwebapi/user',
        c: 'webuser_api',
        a: 'quyangtypeinfo'
      }, URL);
      var data = {
        zrctoken: that.$data.zrctoken,
        id: that.dingdaninfo.xzquyangtypeid
      };
      baseTokenPost(that.$data.zrctoken, url, data, function (res) {
        that.quyangtype_beizhu = res.data.info.quyangtypeinfo.info.quyangtypeinfo.beizhu;
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //提交客户合同附件保存
    tijiaodingdan: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi/user',
        c: 'webuser_api',
        a: 'projectadddingdan'
      }, URL);
      var data = that.$data.dingdaninfo;
      data['zrctoken'] = that.$data.zrctoken;
      baseTokenPost(that.$data.zrctoken, url, data, function (res) {
        router.push({
          path: '/huiyuan'
        });
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //上传任务图片
    upload_file: function (params) {
      var that = this;
      console.log('自带参数' + JSON.stringify(params));
      var type = params.data.type;
      var index = params.data.index;
      let file = params.file;
      let imageType = file.type;
      console.log('上传文件类型' + imageType);
      var isLtshiM = file.size / 1024 / 1024 < 30;
      if (!isLtshiM) {
        this.loading.close();
        Tips('视频最大不能超过30M!', 'warning');
        return;
      }
      var fileName = that.$data.folderName + new Date().getTime() + Math.floor(Math.random() * 150) + file.name;
      console.log('阿里云上传文件' + fileName);
      client().multipartUpload(fileName, file, {
        headers
      }, {
        progress: function (percentage, cpt) {
          console.log('打印进度', percentage);
        }
      }).then(res => {
        console.log('阿里云传成功返回1' + res);
        this.loading.close();
        if (type == 1)
          //跟进资源
          {
            that.dingdaninfo.fujianname.push(file.name);
            that.dingdaninfo.fujianlist.push("https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/" + fileName);
            Tips('上传成功', 'success');
          }
      });
    },
    //上传任务图片

    // 失败
    handleUploadError() {
      this.$message({
        type: "error",
        message: "上传失败"
      });
      this.loading.close();
    },
    // 上传文件之前
    handleBeforeUpload() {
      this.loading = this.$loading({
        lock: true,
        text: "上传中",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    //删除附件
    del_dingdaninfo_source: function (index) {
      var that = this;
      that.dingdaninfo.fujianname.splice(index, 1);
      that.dingdaninfo.fujianlist.splice(index, 1);
    }
  },
  mounted: function () {
    var that = this;
    that.getdengluzt();
  }
};